<div class="cases">

	<ansyn-cases-tools></ansyn-cases-tools>
	<ansyn-cases-table></ansyn-cases-table>
	<ansyn-cases-modal-container></ansyn-cases-modal-container>

</div>


